import {
    QUEUE_LIST_REQUEST_QUEUES,
    QUEUE_LIST_RECEIVE_QUEUES,
    QUEUE_LIST_FILTER,
    QUEUE_LIST_FILTER_BY_CURRENT_PERIOD,
    QUEUE_LIST_TOGGLE_QUEUE_COLLAPSE
} from "../config/actions";
import config from '../config/config';
import axios from 'axios';

export function getQueueList() {
    return dispatch => {
        dispatch({
            type: QUEUE_LIST_REQUEST_QUEUES
        });
        axios(config.server.endpoint + 'backend/queue', {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                dispatch({
                    type: QUEUE_LIST_RECEIVE_QUEUES,
                    queues: response.data.queues,
                    availableCurrentPeriods: response.data.availableCurrentPeriods
                });
            }
        })
    }
}

export function filterQueueList(searchString) {
    return {
        type: QUEUE_LIST_FILTER,
        searchString: searchString
    }
}

export function filterQueueListByCurrentPeriod(periods) {
    return {
        type: QUEUE_LIST_FILTER_BY_CURRENT_PERIOD,
        periods: periods
    }
}

export function removeSupporterFromQueue(supporterId) {
    return dispatch => {
        axios(config.server.endpoint + 'backend/queue/supporter/' + supporterId, {
            method: 'delete'
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    dispatch(getQueueList());
                }
            }
        });
    }
}

export function setSupporterToPeriodAndRemoveFromQueue(supporterId) {
    return dispatch => {
        axios(config.server.endpoint + 'backend/queue/supporter/' + supporterId, {
            method: 'PUT'
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    dispatch(getQueueList());
                }
            }
        });
    }
}

export function toggleQueueCollapse(queueId) {
    return {
        type: QUEUE_LIST_TOGGLE_QUEUE_COLLAPSE,
        id: queueId
    }
}